import { Capacitor } from '@capacitor/core';
import { isCapacitorNative } from 'Utils/Constants';

/**
 * The app platforms whose native audio follows the volume settings: the
 * MuseFlowAudio plugin takes every channel's gain there (MUS-652).
 */
const APP_PLATFORMS_WITH_VOLUME: readonly string[] = ['ios', 'android'];

/**
 * Whether the volume controls work on this platform. On an app platform whose
 * native audio does not follow the settings the controls stay hidden, rather
 * than showing and doing nothing.
 */
export const volumeControlsAvailable = (): boolean =>
  !isCapacitorNative() || APP_PLATFORMS_WITH_VOLUME.includes(Capacitor.getPlatform());
